import { render } from "./CommunicationView.vue?vue&type=template&id=029c5f41&scoped=true&ts=true"
import script from "./CommunicationView.vue?vue&type=script&lang=ts"
export * from "./CommunicationView.vue?vue&type=script&lang=ts"

import "./CommunicationView.vue?vue&type=style&index=0&id=029c5f41&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029c5f41"]])

export default __exports__